import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { Accordion } from 'react-bootstrap'
import { base_url } from '../../Helper/request';
import { useEffect } from 'react';
const FaqData = () => {
    const [faqData, setfaqData] = useState([]);
    useEffect(() => {
        getFaqData();
    }, [])
    const getFaqData = async () => {
        const options = {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
        };
        await axios.get(base_url + "/common/faq", options).then((res) => {
            if (res && res.status === 200) {
                setfaqData(res?.data?.data);
            }
        });
    };
    return (
        <div className="csContent anchorPdf">
            <Accordion>
                {
                    faqData.length > 0 && faqData?.map((e, i) => (
                        <Accordion.Item eventKey={e?.id} key={i}>
                            <Accordion.Header>{e?.title}</Accordion.Header>
                            <Accordion.Body><div dangerouslySetInnerHTML={{ __html: e?.value }} /></Accordion.Body>
                        </Accordion.Item>
                    ))
                }
            </Accordion>

        </div>
    )
}

export default FaqData